import React from 'react'
import { Images } from '../../../utils/imageConstants'

const BackgroundBatman: React.FC = () => {
  return (
    <div className="statgpt-background-batman">
      <img src={Images.batman_bg_image} alt="" />
    </div>
  )
}

export default BackgroundBatman

